import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SharedService} from '../Shared/Services/shared.service';
import {environment} from '../../environments/environment'
import {DtoProductCostVM} from '../Model/cost-calculation/DtoProductCostVM';
import {AdditionalDetails, CostCalculationVM} from '../Model/cost-calculation/CostCalculationVM';

@Injectable({
  providedIn: 'root'
})
export class CostCalculationService {
  readonly APIurl = environment.apiUrl;

  constructor(private http: HttpClient, private shared: SharedService) {
  }

  GetCostCalculationData(form?: any, index?: number, AllCostNames?: string[]): CostCalculationVM {
    let data: CostCalculationVM = {};
    data.subCategoryId = form?.controls['typeId_' + index]?.value;
    data.height = form?.controls['height_' + index]?.value;
    data.price = form?.controls['price_' + index]?.value ?? null;
    data.count = form?.controls['count_' + index]?.value;
    data.width = form?.controls['width_' + index]?.value;
    data.colorId = form?.controls['colorId_' + index]?.value;
    data.colorName = form?.controls['colorName_' + index]?.value;
    data.typeName = form?.controls['typeName_' + index]?.value;
    data.typeId = form?.controls['typeId_' + index]?.value;
    data.glassTypeId = form?.controls['glassTypeId_' + index]?.value;
    data.glassTypeName = form?.controls['glassTypeName_' + index]?.value;
    data.halkId   = form?.controls['halkId_' + index]?.value ?? null;
  // (data as any).halkName = form?.controls['halkName_' + index]?.value ?? null;
    data.AdditionalDetails = [];

    Object.keys(form?.controls).forEach(key => {
      let splited = key.split('_')[0];
      let idx = Number(key.split('_')[1]);
      if (AllCostNames?.includes(splited) && index === idx) {
        if (form?.controls[splited + '_' + index]?.value?.id) {
          data.AdditionalDetails?.push({
            id: form?.controls[splited + '_' + index]?.value?.id,
            name: form?.controls[splited + '_' + index]?.value?.name,
            height: form?.controls[splited + '_' + index]?.value?.height,
            price: form?.controls[splited + '_' + index]?.value?.price ?? null,
            width: form?.controls[splited + '_' + index]?.value?.width,
            value: form?.controls[splited + '_' + index]?.value?.value
          });
        }
      }
    });

    return data;
  }

GetDtoProductCost(form?: any, index?: number, AllCostNames?: string[]): DtoProductCostVM {
  const glassId = form?.controls['glassTypeId_' + index]?.value;
  const halkId  = form?.controls['halkId_' + index]?.value;

  const types: number[] = [];
  if (glassId) types.push(glassId);
  if (halkId)  types.push(halkId);

  let Product: DtoProductCostVM = {
    subCategoryId: form?.controls['typeId_' + index]?.value,
    width: form?.controls['width_' + index]?.value?.toString(),
    height: form?.controls['height_' + index]?.value?.toString(),
    meterPriceForClient: form?.controls['price_' + index]?.value ?? null,
    count: form?.controls['count_' + index]?.value,
    colorId: form?.controls['colorId_' + index]?.value,
    types: types,                          // <-- هنا بقت تشمل halkId
    costCalcAdds: [],
    expenses: 0
  };

  if (!Product.meterPriceForClient) {
    Product.meterPriceForClient = null;
  }

  Object.keys(form?.controls).forEach(key => {
    let splited = key.split('_')[0];
    let idx = Number(key.split('_')[1]);
    if (AllCostNames?.includes(splited) && index === idx) {
      if (form?.controls[splited + '_' + index]?.value?.id) {
        Product.costCalcAdds?.push({
          costCalcAddNameId: form?.controls[splited + '_' + index]?.value?.id,
          name: form?.controls[splited + '_' + index]?.value?.name,
          height: form?.controls[splited + '_' + index]?.value?.height,
          meterCost: form?.controls[splited + '_' + index]?.value?.price,
          width: form?.controls[splited + '_' + index]?.value?.width,
          value: form?.controls[splited + '_' + index]?.value?.value
        });
      }
    }
  });

  return Product;
}


GetDtoProductCostArrVM(inputData?: any[]): DtoProductCostVM[] {
  let data: DtoProductCostVM[] = [];
  inputData?.forEach(item => {
    const mergedTypes = Array.from(new Set([
      ...(item.glassTypeId ? [item.glassTypeId] : []),
      ...(item.halkId ? [item.halkId] : []),          // <-- إضافة halkId
    ]));

    let obj: DtoProductCostVM = {
      subCategoryId: item.subCategoryId,
      colorId: item.colorId,
      width: item.width?.toString(),
      height: item.height?.toString(),
      meterPriceForClient: item.price ?? null,
      types: mergedTypes,                              // <-- هنا
      count: item.count,
      expenses: 0,
      costCalcAdds: []
    };
    if (!obj.meterPriceForClient) {
      obj.meterPriceForClient = null;
    }

    item?.AdditionalDetails?.forEach((info: AdditionalDetails) => {
      if (info?.id) {
        obj.costCalcAdds?.push({
          costCalcAddNameId: info?.id,
          height: info?.height,
          meterCost: info?.price,
          width: info?.width,
          value: info?.value
        });
      }
    });

    data.push(obj);
  });

  return data;
}


  GetColorsForWorkShop() {
    return this.http.get(`${this.APIurl}/Colors/GetColorsForWorkShop`, this.shared.options);
  }

  GetAllTypes() {
    return this.http.get(`${this.APIurl}/ProductTypes/GetAllTypes`, this.shared.options);
  }

  GetAllCostCalcAddsNames() {
    return this.http.get(`${this.APIurl}/CostCalcToClient/GetAllCostCalcAddsNames`, this.shared.options);
  }

  GetOrderInfo(data: any) {
    return this.http.post(`${this.APIurl}/ProductIngredients/GetOrderInfoForSector`, data, this.shared.options);
  }

  UpdateListCostCalcToClient(data: any) {
    return this.http.post(`${this.APIurl}/CostCalcToClient/UpdateListCostCalcToClient`, data, this.shared.options);
  }

  GetListTotalPriceForClient(data: any) {
    let dto = this.GetDtoProductCostArrVM(data.products);
    return this.http.post(`${this.APIurl}/ProductIngredients/GetListTotalPriceForClient`, dto, this.shared.options);
  }

  GetSector() {
    return this.http.get(`${this.APIurl}/sector`, this.shared.options);
  }

  SectorProductComparison(data: any) {
    return this.http.post(`${this.APIurl}/SectorProductComparison`, data, this.shared.options);
  }

  GetTotalCost(data: any) {
    if(data.sectorId === "") {
      data.sectorId = null;
    }
    return this.http.post(`${this.APIurl}/ProductIngredients/GetTotalCostForSector`, data, this.shared.options);
  }

  GetAllProductIngredient() {
    return this.http.get(`${this.APIurl}/ProductIngredients/GetAllProductIngredient`, this.shared.options);
  }

  GetAllParentSubCategory(sectorId: string | null) {
    return this.http.get(`${this.APIurl}/CategoryCost/GetAllParentSubCategory${sectorId ? '?sectorId=' + sectorId : ''}`, this.shared.options);
  }
}
